import React from 'react';
import PropTypes from 'prop-types';
import styled from 'styled-components';
import { ScreenReaderText } from '@utils';
import breakpoints from '@repo/ui-components/breakpoints';

const iconHeight = 42;

const Container = styled.div`
  display: flex;
`;

const SocialLink = styled.a`
  height: ${iconHeight}px;
  width: ${iconHeight}px;
  margin: 0 1.5vw;
  cursor: pointer;

  @media (min-width: ${breakpoints.md}) {
    margin-left: 0;
    margin-right: 0.5vw;
  }

  img {
    max-height: 100%;
  }
`;

function SocialIcons({ socialLinks }) {
  return (
    <Container>
      {socialLinks.map(linkItem => (
        <SocialLink
          href={linkItem.link}
          rel="noopener noreferrer"
          target="_blank"
          key={linkItem.link}
        >
          {linkItem.icon ? (
            <linkItem.icon
              width={iconHeight}
              alt={linkItem.iconAltText}
              height={iconHeight}
            />
          ) : (
            linkItem.title
          )}
          <ScreenReaderText>{linkItem.title}</ScreenReaderText>
        </SocialLink>
      ))}
    </Container>
  );
}

SocialIcons.propTypes = {
  socialLinks: PropTypes.arrayOf(
    PropTypes.shape({
      title: PropTypes.string,
      link: PropTypes.string,
      icon: PropTypes.shape({
        asset: PropTypes.shape({
          url: PropTypes.string,
        }),
      }),
      iconAltText: PropTypes.string,
    })
  ),
};

SocialIcons.defaultProps = {
  socialLinks: [],
};

export default SocialIcons;
